import { useTranslation } from 'contexts/Localization'
import { useCallback, useState, KeyboardEvent } from 'react'
import { useUserConfirmationManager } from 'state/user/hooks'
import { Button, Flex, Input, Message, Modal } from 'vvs-uikit'

interface Props {
  title: string
  message: string
  callback: () => void
}
const DoubleConfirmModal: React.FC<Props> = ({ title, message, callback }) => {
  const { t } = useTranslation()
  const [confirm, , unconfirm] = useUserConfirmationManager()
  const [value, setValue] = useState<string>()

  const onConfirm = useCallback(() => {
    if (value === 'confirm') {
      confirm()
      callback()
    }
  }, [callback, confirm, value])

  const handleEnter = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        onConfirm()
      }
    },
    [onConfirm],
  )

  return (
    <Modal title={title} onBack={() => unconfirm()} onDismiss={() => unconfirm()}>
      <Message variant="danger">{message}</Message>
      <Flex flexDirection="column" gap="1rem" mt={3}>
        <Input
          autoCapitalize="off"
          value={value}
          onChange={(evt) => setValue(evt.target.value)}
          onKeyPress={handleEnter}
        />
        <Button onClick={onConfirm}>{t('Confirm')}</Button>
      </Flex>
    </Modal>
  )
}

export default DoubleConfirmModal
